import { getAttributeValue } from "../../../sections/plentyHelpers";

export default {
  state: {
    width: 0,
    selection: {},
    options: [],
  },

  mutations: {
    setWidth(state, value) {
      if (value.target) return (state.width = Number(value.target.value));
      state.width = Number(value);
    },

    setLength(state, value) {
      if (value.target) return (state.length = Number(value.target.value));
      state.length = Number(value);
    },

    setSelection(state, value) {
      state.selection = value;
    },

    setDimensionVariations(state, variations) {
      state.options = variations;
    },
  },

  getters: {
    numberOfArms(state) {
      if (!state.selection) return null;

      return Number(getAttributeValue(state.selection, "Arme"));
    },
  },
};
